import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {LB_CODE, LB_ACTIVE, LB_TITLE} from "../../../components/i18n/i18n";
import {PH_CODE, PH_TITLE} from "../../../components/i18n/placeHolders";
import {FL_CATEGORY, FL_ONLY_REGISTERED, FL_PLACE} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import {placeProvider} from "../../../providers/placeProvider";



const ActivityFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app, udn } = componentState?.data || {};
    const {fbDataBase} = app

    const [categoryId, setCategoryId] = useState(filter?.item?.category?.id != null ? filter?.item?.category?.id : null);
    const [placeId, setPlaceId] = useState(filter?.item?.place?.id != null ? filter?.item?.place?.id : null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);
    const [resetValue, setResetvalue] = useState(false);
    const [status, setStatus] = useState(filter?.status || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            title: filter?.title || '',
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            onlyRegistered,
            item : {
                ...data,
                udn : { id : udn.id },
            }
        };

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        if(categoryId != null)
            dataFilter.item.category = { id: categoryId }

        if(placeId != null)
            dataFilter.item.place = { id: placeId }

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        setCategoryId(null);
        setPlaceId(null);
        setResetvalue(!resetValue);
        reset({
            title: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{LB_TITLE}</Label>
                        <Input
                            type="text"
                            name="title"
                            placeholder={PH_TITLE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label>{LB_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_ONLY_REGISTERED }</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={onlyRegistered}
                            onChange={ () => setOnlyRegistered(!onlyRegistered) }
                        />
                    </FormGroup>
                </Col>


                <Col md="2">
                    <FormGroup>
                        <Label>{LB_ACTIVE}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>

                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_CATEGORY }</Label>
                        <SelectGeneric
                            setExternalValue = { value => setCategoryId( value ) }
                            isDisabled = { false }
                            provider = { hotelCategoryProvider }
                            getAllCategories = { true }
                            resetValue={ resetValue }
                        />
                    </FormGroup>
                </Col>

                <Col md="3">
                    <FormGroup>
                        <Label>{ FL_PLACE }</Label>
                        <SelectGeneric
                            setExternalValue={value => setPlaceId(value)}
                            isDisabled={false}
                            provider={placeProvider}
                            customFilter={{item: {udn: {id: udn.id}}}}
                            resetValue={resetValue}
                        />
                    </FormGroup>
                </Col>

                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(ActivityFilters)